var toString = {}.toString;
var isType = function isType(value, type) {
  return toString.call(value) === '[object ' + type + ']';
};

module.exports = isType;


//////////////////
// WEBPACK FOOTER
// ./~/@antv/adjust/~/@antv/util/lib/type/is-type.js
// module id = 120
// module chunks = 3